import { Controller } from "remult";

@Controller("partner-organization-methods")
export class PartnerOrganizationMethods {}
